// extracted by mini-css-extract-plugin
module.exports = {"text_input":"TextInput-module__text_input___2dWvs"};